import styled from 'styled-components';

export const Actions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.75rem;
`;

export const FormBlock = styled.div`
	margin-top: 1.5rem;
`;
